import { ResponseObject } from "../classes/main";

export class ApiService {
  constructor() {}
  public defaultHub: string = "noida";
  private baseUrl: string =
    process.env.NEXT_PUBLIC_API_BASE_URL || "https://customer-apis.tym.llc";
  public hubSeo: string = "/web/v1/hub/seo-content";
  public categories: string = "/web/v1/categories";
  public subcategories: string = "/web/v1/subcategories";
  public servicesheadings: string = "/web/v1/servicesheadings";
  public serviceGuideSteps: string = "/services/product-details?serviceId=";
  public home: string = "/web/v1/home";
  public programs: string = "/web/v1/programs";
  public customer: string = "/customer/";
  public banners: string = "/banners/all";
  public bannersPageContent: string = "/page-contents?id=";
  public headerBanner: string = "/banners/header";
  public headerBannerMobile: string = "/banners/header/all";
  public sendOtp: string = "/customer/send-otp";
  public verifyOtp: string = "/customer/otp/verification";
  public appintments: string = "/web/v1/appointments";
  public myOrders: string = "/orders/my";
  public scanProduct: string = "/orders/scan-barcode?";
  public findMyOrders: string = "/orders/find-by-id?id=";
  public sharedAddress: string = "/orders/shared-address?oid=";
  public orderPaymentMethods: string = "/orders/payment-methods";
  public orderPayNowPayment: string = "/orders/pay-now?";
  public feedBackPoints: string = "/orders/professional-statements?rating=";
  public feedBackBookingCompletion: string = "/orders/feedback?id=";
  public customerDetails: string = "/customer/";
  public saveAddress: string = "/customer/add-address";
  public updateCustomerDetails: string = "/customer/update";
  public customerAddresses: string = "/customer/address/all";
  public deleteCustomerAddresses: string = "/customer/delete-address-by-id";
  public updateCustomerAddresses: string = "/customer/update-address";
  public cartCalculation: string = "/cart/calculation";
  public checkAvailability: string = "/check-availability";
  public calendar: string = "/calendar";
  public slots: string = "/slots";
  public orderSummery: string = "/orders/summary";
  public createOrder: string = "/orders/add";
  public rescheduleOrder: string = "/orders/reschedule";
  public storeCategories: string = "/products/categories";
  public storeSubCategories: string = "/products/sub-categories?";
  public storeSubCategoriesProducts: string = "/products?";
  public storeProductsBanners: string = "/products/banners";
  public storeProductOrder: string = "/product-order";
  public storeAddToCartProducts: string = "/product-order/cart"; //post
  public storeProductsCart: string = "/product-order/cart"; //get
  public storeUpdateCartProducts: string = "/product-order/cart/modify";
  public storeCancelProductsCart: string = "/product-order/cancel?";
  public storePlacedOrdersCart: string = "/product-order"; //get
  public storeProductsPlacedOrderCart: string = "/product-order"; //post
  public bestSellingPackage: string = "/general-package";
  public quickCheckoutAndHomeDetails: string = "/home?";
  public claimServicesWithoutLogin: string =
    "/services/claim-your-free-service";
  public claimServicesWithLogin: string = "/services/claim-your-free-services";
  public dealOfTheDay: string = "/services/deal-of-the-day";
  public subscriptionsWithoutLogin: string = "/customer/subscriptions";
  public subscriptionsWithLogin: string =
    "/customer/subscriptions/after-login?";
  public getServicesInOneRs: string = "/services/find-my-parents?";
  public searchServicesKeywords: string = "/services/keywords?query=";
  public searchServicesWithName: string = "/services/search?query=";
  public cartRecommendService: string = "/cart/recommend";
  public orderConfirmedThankYou: string = "/orders/thank-you?oid=";
  public claimFreeService: string = "/cart/claim-your-free-service";
  public validateClaimFreeService: string = "/claim-services/validate";
  public razorpayValidation: string = "/payment/razorpay/validate";
  public razorpayCreateOrder: string = "/payment/razorpay/create-order";
  public subscribedCustomer: string = "/customer/subscriptions/apply";
  public franchiseDetails: string = "/franchise";
  public saveFranchiseDetails: string = "/franchise";
  public walletBalance: string = "/customer/wallet/passbook";
  public makeYourOwnPackage: string = "/subcategories/make-your-own-package?";
  public orderCancelReasons: string = "/orders/cancel-reasons";
  public orderCancel: string = "/orders/cancel";
  public expertLeads: string = "/expert-leads";
  public disposableItems: string = "/disposable-kit-items";
  public checkServiceOnAddressChange: string =
    "/services/checkout/verify-services-on-address-change";

  // Method to get the full URL for a specific endpointPwqw
  private getFullUrl(endpoint: string): string {
    return `${this.baseUrl}${endpoint}`;
  }
  // Method to get the default hub
  public getDefaultHub(): string {
    return this.defaultHub;
  }

  public setDefaultHub(hub: string) {
    this.defaultHub = hub;
  }
  private buildRequestHeaders(
    token?: string,
    hubId?: number
  ): Record<string, string> {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      "x-buildnumber": String(131),
    };
    if (token) headers.Authorization = token;
    if (hubId !== undefined && hubId !== null)
      headers["x-hubId"] = String(hubId);
    return headers;
  }

  // Generic GET request method
  public async get<ResponseObject>(
    endpoint: string,
    token?: string,
    hubId?: number
  ): Promise<ResponseObject | undefined> {
    const url = this.getFullUrl(endpoint);
    // console.log(url);
    try {
      const response = await fetch(url, {
        cache: "no-store",
        headers: this.buildRequestHeaders(token, hubId),
      });
      // if (!response.ok) {
      //   throw new Error(
      //     `GET request to ${url} failed with status ${response.status}`
      //   );
      // }
      return response.json() as ResponseObject;
    } catch (error) {
      // Check if the error is a network issue (e.g., DNS resolution failure or unreachable server)
      if (error instanceof TypeError && error.message === "Failed to fetch") {
        const errorMessage = `
          This site can’t be reached
          ${url}’s server IP address could not be found.
        `;
        console.error(errorMessage);
        return undefined;
      }
    }
  }

  // Generic POST request method
  public async post<ResponseObject>(
    endpoint: string,
    data: any,
    token?: string,
    hubId?: number
  ): Promise<ResponseObject | undefined> {
    const url = this.getFullUrl(endpoint);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token!,
          "x-buildnumber": String(131),
          ...(hubId !== undefined && { "x-hubId": String(hubId) }), // Add x-hubId conditionally
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error(
          `POST request to ${url} failed with status ${response.status}`
        );
      }
      return response.json() as ResponseObject;
    } catch (error) {
      // Check if the error is a network issue (e.g., DNS resolution failure or unreachable server)
      if (error instanceof TypeError && error.message === "Failed to fetch") {
        const errorMessage = `
        This site can’t be reached
        ${url}’s server IP address could not be found.
      `;
        console.error(errorMessage);
        return undefined;
      }
    }
  }

  // Generic DELETE request method
  public async delete<ResponseObject>(
    endpoint: string,
    token?: string,
    hubId?: number
  ): Promise<ResponseObject> {
    const url = this.getFullUrl(endpoint);
    const response = await fetch(url, {
      method: "DELETE",
      cache: "no-store",
      headers: this.buildRequestHeaders(token, hubId),
    });
    if (!response.ok) {
      throw new Error(
        `DELETE request to ${url} failed with status ${response.status}`
      );
    }
    return response.json() as ResponseObject;
  }

  // Generic PUT request method
  public async put<ResponseObject>(
    endpoint: string,
    data: any,
    token?: string
  ): Promise<ResponseObject> {
    const url = this.getFullUrl(endpoint);
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = token;
    const response = await fetch(url, {
      method: "PUT",
      cache: "no-store",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(
        `PUT request to ${url} failed with status ${response.status}`
      );
    }

    return response.json() as ResponseObject;
  }
}
